import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { mmAttachmentConstants } from './attachment-constants';
import { en } from './i18n/en';
import { zh } from './i18n/zh';

export const mmAttachmentTranslationGroup = {
    groupName: mmAttachmentConstants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }

} as TranslationGroup